export const gallerySelector = (state: any) => state.gallery;
export const galleriesMapSelector = (state: any) =>
  state.collection.galleries.reduce((acc, gallery) => {
    // eslint-disable-next-line
    acc[gallery._id] = gallery;

    return acc;
  }, {});
